import { Theme, CSSObject, alpha } from "@mui/material/styles";

interface NavbarStylesProps {
  theme: Theme;
  open: boolean;
  drawerWidth: number;
  isMobile: boolean;
  location: any;
}

const NavbarStyles = {
  // Group Header Styles
  groupHeaderContainer: {
    display: "flex",
    px: 2,
    py: 1,
  },

  groupHeaderBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flex: 1,
  },

  groupHeaderTypography: {
    fontWeight: 600,
    fontSize: 14,
    color: "text.secondary",
  },

  // Collapsed Group Header Styles
  collapsedGroupContainer: {
    display: "block",
  },

  collapsedGroupButton: (
    theme: any,
    expanded: boolean,
    isGroupActive: boolean
  ) => ({
    justifyContent: "center",
    minHeight: 48,
    backgroundColor:
      expanded || isGroupActive
        ? alpha(theme.palette.primary.main, 0.08)
        : "transparent",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
  }),

  collapsedGroupIcon: (
    theme: any,
    expanded: boolean,
    isGroupActive: boolean
  ) => ({
    width: 24,
    justifyContent: "center",
    "& .MuiSvgIcon-root": {
      fill: expanded || isGroupActive ? theme.palette.primary.main : undefined,
    },
  }),

  // Group Items Styles
  groupItemContainer: {
    display: "block",
    pl: 0,
  },

  groupItemButton: (theme: any, open: boolean, isActive: boolean) => ({
    justifyContent: open ? "flex-start" : "center",
    minHeight: 40,
    px: 2,
    py: 0.6,
    backgroundColor: isActive
      ? alpha(theme.palette.primary.main, 0.08)
      : "transparent",
    "&:hover": {
      backgroundColor: isActive
        ? alpha(theme.palette.primary.main, 0.15)
        : alpha(theme.palette.primary.main, 0.08),
    },
  }),

  groupItemIcon: (theme: any, isActive: boolean) => ({
    color: "rgba(0, 0, 0, 0.87)",
    width: 24,
    justifyContent: "center",
    "& .MuiSvgIcon-root": {
      fill: isActive ? theme.palette.primary.main : undefined,
    },
  }),

  groupItemText: (open: boolean, theme: any, isActive: boolean) => ({
    opacity: open ? 1 : 0,
    "& .MuiTypography-root": {
      color: isActive ? theme.palette.primary.main : undefined,
      fontSize: 14,
    },
  }),

  // Divider styles
  divider: {
    my: 1,
  },

  // Settings item styles
  settingsListItem: {
    disablePadding: true,
    sx: {
      display: "block",
    },
  },

  settingsButton: (props: NavbarStylesProps) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: props.open ? "flex-start" : "center",
    paddingX: props.open ? 2 : 4.5,
    paddingY: 0.6,
    gap: 1,
    minHeight: 40,
    backgroundColor: (theme: Theme) =>
      props.location.pathname === "/admin/settings"
        ? alpha(theme.palette.primary.main, 0.08)
        : "transparent",
    "&:hover": {
      backgroundColor: (theme: Theme) =>
        props.location.pathname === "/admin/settings"
          ? alpha(theme.palette.primary.main, 0.15)
          : alpha(theme.palette.primary.main, 0.08),
    },
  }),

  settingsIcon: (props: NavbarStylesProps) => ({
    minWidth: "unset",
    margin: 0,
    display: "flex",
    justifyContent: "center",
    width: 24,
    "& .MuiSvgIcon-root": {
      fill:
        props.location.pathname === "/admin/settings"
          ? props.theme.palette.primary.main
          : "unset",
    },
  }),

  settingsText: (props: NavbarStylesProps) => ({
    opacity: props.open ? 1 : 0,
    "& .MuiTypography-root": {
      color:
        props.location.pathname === "/admin/settings"
          ? props.theme.palette.primary.main
          : "unset",
      fontSize: "14px",
    },
  }),

  // Group icon styles
  groupIcon: {
    fontSize: "small",
    sx: {
      color: "rgba(0, 0, 0, 0.87)",
    },
  },
};

export default NavbarStyles;
